export default __webpack_public_path__ + "static/media/logo-mini.47d2c54d.svg";